import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PayDetailsDialogComponent } from '../pays-details-dialog/pay-details-dialog.component';
import { IDateRange } from '../../../../interfaces/date-range.interfaces';
import { formatUiDate } from '../../../../shared/date/date.utils';

@Component({
    selector: 'app-pay-period-dialog',
    templateUrl: './pay-period-dialog.component.html',
    styleUrls: ['./pay-period-dialog.component.scss'],
    standalone: false
})
export class PayPeriodDialogComponent implements OnInit {
    public periodText = '';
    public newDate: IDateRange;

    public constructor(
        public dialogRef: MatDialogRef<PayDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { dateRange: IDateRange },
    ) {
        this.newDate = data.dateRange;
        this.changePeriod(this.newDate);

        this.periodText = this.getPeriodText(this.newDate);
    }

    public ngOnInit(): void {}

    /** Изменение периода для вывода записей*/
    public changePeriod(dt: IDateRange): void {
        this.newDate = dt;
        this.formatDateToString(this.newDate);
        this.periodText = this.getPeriodText(this.newDate);
    }

    /** Сброс выбранного периода */
    public resetPeriod() {
        this.newDate = this.data.dateRange;
        this.periodText = this.getPeriodText(this.newDate);
    }

    /** Получнеи текста из периода */
    public getPeriodText(dt: IDateRange): string {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin == dt.str_end;
        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'Выберите день или период';
            else if (dt.dt_begin?.toDateString() == new Date().toDateString())
                periodText = formatUiDate(dt.dt_begin);
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.str_begin && dt.str_end) {
            periodText = `${dt.str_begin} - ${dt.str_end}`;
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }
        return periodText;
    }

    /** Создание строковйх представлений для переданного значения */
    public formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = formatUiDate(dt.dt_begin);
        }
        if (dt.dt_end) {
            dt.str_end = formatUiDate(dt.dt_end);
        }
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */

    public btnFilterByDay(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.newDate.dt_begin = new Date();
            this.newDate.dt_begin.setDate(
                this.newDate.dt_begin.getDate() - startOffset,
            );
            this.newDate.dt_end = new Date();
            this.newDate.dt_end.setDate(
                this.newDate.dt_end.getDate() - endOffset,
            );
            this.changePeriod({
                dt_begin: this.newDate.dt_begin,
                dt_end: this.newDate.dt_end,
            });
        } else {
            // this.changePeriod({ dt_begin: null, dt_end: null });

            this.newDate = {
                dt_begin: new Date(2000, 0, 1),
                dt_end: new Date(),
            };
            this.changePeriod({
                dt_begin: new Date(2000, 0, 1),
                dt_end: new Date(),
            });
        }

        // this.apply();
    }

    /** Закрытие окна с передачей результата */
    public apply() {
        if (this.newDate) {
            this.dialogRef.close({ date: this.newDate });
        }
    }

    /** Закрытие окна */
    public close() {
        this.dialogRef.close();
    }
}
